<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-container>
      <h2 v-html="$t('password.title', {username:getUsername})"></h2>

      <v-row justify="center" align="center" class="">
        <v-col cols="12">
          <v-label class="mr-4">{{$t('global.form.currentpassword')}}</v-label>
          <v-text-field variant="outlined" density="compact" :hide-details="true" :placeholder="$t('global.form.currentpassword-placeholder')">
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-label class="mr-4">{{$t('global.form.newpassword')}}</v-label>
          <v-text-field variant="outlined" density="compact" :hide-details="true" :placeholder="$t('global.form.newpassword-placeholder')">
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-label class="mr-4">{{$t('global.form.confirmpassword')}}</v-label>
          <v-text-field variant="outlined" density="compact" :hide-details="true" :placeholder="$t('global.form.confirmpassword-placeholder')">
          </v-text-field>
        </v-col>
        <v-col>
          <v-btn variant="flat" size="large" color="primary" rounded="xl"
            class="white--text mb-2 find-favourites-button">{{$t('entity.action.save')}}</v-btn>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
</template>

<script>
import { ref,computed } from 'vue';

export default {
  data() {
    return {
      tab: 'Lieblingsmarken',
    }
  },
  setup() {
     

    const getUsername = computed(() => {
      return localStorage.getItem("username");
    });
    return {
      
      getUsername

    };
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  width: 900px;
}

.v-tab-selected {
  text-decoration: underline;
}

.v-tab {
  font-size: 26px;
  font-weight: 800;
  font-family: Montserrat, sans-serif;
  letter-spacing: normal;
}

.v-btn.find-favourites-button {
  font-size: 14px;
  font-weight: 400;
}
</style>